
import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import SharedFooter from '../../components/feature/SharedFooter';
import PricingHero from './components/PricingHero';
import OpticaModule from './components/OpticaModule';
import ComparisonTable from './components/ComparisonTable';
import PricingFAQ from './components/PricingFAQ';
import PricingCTA from './components/PricingCTA';

export default function PricingPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <PricingHero />
      <OpticaModule />
      <ComparisonTable />
      <PricingFAQ />
      <PricingCTA />
      <SharedFooter />
    </div>
  );
}
